import { AuthLayout } from '@app/layouts';
import { PasswordReset } from '@app/auth/components/PasswordReset';

export const PasswordResetParentPage = () => {
  return (
    <AuthLayout>
      <PasswordReset isParent />
    </AuthLayout>
  );
};
